'use strict';

var React = require('react');

var SvgWandMajor = function SvgWandMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.737 3.677a1.75 1.75 0 0 0-2.474 0l-8.586 8.585a1.75 1.75 0 0 0 0 2.475l1.586 1.586a1.75 1.75 0 0 0 2.474 0l6.784-6.784.01-.009.008-.009 1.784-1.784a1.75 1.75 0 0 0 0-2.475l-1.586-1.585Zm-.737 4.262 1.263-1.262a.25.25 0 0 0 0-.354l-1.586-1.586a.25.25 0 0 0-.354 0l-1.262 1.263 1.939 1.94Zm-3-.878-6.263 6.262a.25.25 0 0 0 0 .354l1.586 1.585a.25.25 0 0 0 .354 0l6.262-6.262-1.94-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12a.75.75 0 0 1 .75.75v.75h.75a.75.75 0 0 1 0 1.5h-.75v.75a.75.75 0 0 1-1.5 0v-.75h-.75a.75.75 0 0 1 0-1.5h.75v-.75a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.25a.75.75 0 0 0-1.5 0v.75h-.75a.75.75 0 0 0 0 1.5h.75v.75a.75.75 0 0 0 1.5 0v-.75h.75a.75.75 0 0 0 0-1.5h-.75v-.75Z"
  }));
};
SvgWandMajor.displayName = "WandMajor";

exports.SvgWandMajor = SvgWandMajor;
